module.exports = __webpack_public_path__ + "img/t1-endorsement-statement.6c9f9394.png";